"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_UNIX_TIME = exports.MS_REFRESH_TOKEN_BEFORE_EXPIRY = exports.IDP_ACCESS_TOKEN_ENDPOINT = exports.LOCAL_STORAGE_JWT_EXPIRY = exports.MAX_WAITING_TIME = exports.LOCAL_STORAGE_JWT_LAST_REQUEST_TIME = exports.LOCAL_STORAGE_JWT = exports.LOCAL_STORAGE_JWT_TOKEN = void 0;
exports.LOCAL_STORAGE_JWT_TOKEN = 'jwt_access_token';
exports.LOCAL_STORAGE_JWT = 'jwt';
exports.LOCAL_STORAGE_JWT_LAST_REQUEST_TIME = 'jwt_loading';
exports.MAX_WAITING_TIME = 5 * 1000; // 5 seconds
exports.LOCAL_STORAGE_JWT_EXPIRY = 'jwt_expiry';
exports.IDP_ACCESS_TOKEN_ENDPOINT = '/v7/idp/access-tokens/by-session';
exports.MS_REFRESH_TOKEN_BEFORE_EXPIRY = 5 * 60 * 1000; // 5 minutes
exports.MAX_UNIX_TIME = 9999999999999;
//# sourceMappingURL=constants.js.map